import { useEffect, useState } from 'react';
import { loadMaterialCategoriesCached } from '../api/materialCategory';

// 材料类别编码 → 中文的公共取值器.
// 材料主数据的 type1/type2 存的是类别编码 (categoryCode, 如 Paper / Photo Paper), 中文名在
// material_category.name_zh 里 —— 展示侧从类别树取, 页面不抄 code→中文 表.
// 类别树没这一项时回退原值 (存量脏类别名也能看见, 不吞数据).

export function useCategoryText(): (code?: string) => string {
    const [names, setNames] = useState<Map<string, string>>(new Map());
    useEffect(() => {
        loadMaterialCategoriesCached().then((tree) => {
            const m = new Map<string, string>();
            tree.forEach((l1) => {
                if (l1.nameZh) m.set(l1.categoryCode, l1.nameZh);
                (l1.children || []).forEach((l2) => {
                    if (l2.nameZh) m.set(l2.categoryCode, l2.nameZh);
                });
            });
            setNames(m);
        });
    }, []);
    return (code) => (code ? names.get(code) || code : '');
}
